import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import "/node_modules/flag-icons/css/flag-icons.min.css";

export default function MediaControlCard() {
  const { t } = useTranslation();
  return (
    <Card
      sx={{ maxWidth: 450, margin: "0 auto", my: 5, display: "flex", p: 3 }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Typography component="div" variant="h5">
            {t("bio.private.name")}
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            component="div"
          >
            {t("bio.private.position")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            🎂 1997/09/20
            <br />
            🎓 {t("bio.private.college")}
            <br />
            🏠 {t("bio.private.city")}
            <br />
            💼 {t("bio.private.job")}
            <br />
            🎮 {t("bio.private.hobby")}
            <span className="fi fi-jp"></span>
            <span className="fi fi-fr"></span>
            <span className="fi fi-in"></span>
            <span className="fi fi-fi"></span>
            <span className="fi fi-gb"></span>
            <span className="fi fi-cy"></span>
            <span className="fi fi-tr"></span>
            <span className="fi fi-tw"></span>
            <span className="fi fi-gu"></span>
            <span className="fi fi-hk"></span>
            <span className="fi fi-th"></span>
            <span className="fi fi-kh"></span>
            <span className="fi fi-ph"></span>
            <span className="fi fi-vn"></span>
          </Typography>
        </CardContent>
      </Box>
      <CardMedia
        component="img"
        sx={{ width: "41%", ml: "auto", objectFit: "contain" }}
        image={`${process.env.PUBLIC_URL}/cambodia.webp`}
        alt="matsuki takeshi"
      />
    </Card>
  );
}
